export enum CacheCompleteness {
  PARTIAL = 'partial',
  FULL = 'full',
}
